<div class="container">
  <div class="header">
    <div class="page_title_close_btn">
      <app-page-close-button (click)="goBack()"></app-page-close-button>
      <div class="page_title">
        @if (readOnlyMode) {
          View
        } @else if (editingEnabled) {
          Edit
        } @else {
          Create
        }
        Invoice
      </div>
    </div>

    <div class="save_cancel_btn">

      @if (!readOnlyMode) {

        <button class="secondary_button" (click)="reset()">Reset</button>
        <!--        <button class="secondary_button ghost_button" (click)="goBack()">Cancel</button>-->
        <button class="primary_button add_new_btn" (click)="saveInvoices()">
        <span>
          @if (editingEnabled) {
            Update
          } @else {
            Save
          }
        </span>
        </button>
      } @else {
        <button class="secondary_button add_new_btn" (click)="goBack()">Go Back</button>
      }
    </div>
  </div>
  <div class="content">

    <div class="card_with_stats">
      <div class="card">
        <div class="settings_icon">
          <app-svg-icon [path]="'assets/icons/settings_menu_icon.svg'" (click)="overrideGstSettings()"></app-svg-icon>
        </div>
        <app-dynamic-form [formGroup]="invoiceFrom"
                          [formConfig]="dynamicFormConfig"
                          (onValueChange)="handleSuggestionSelected($event)"></app-dynamic-form>
        <button class="button primary_button" (click)="getInvoiceEstimate()">Fetch Charges
        </button>
      </div>
      @if (invoiceType === InvoiceType.DOCUMENT && showDocumentStats) {
        <app-stats [stats]="documentStats"
                   [headerIconBgColor]="'#B9E6FE'"
                   [headerIconUrl]="'assets/icons/document_icon.svg'"
                   [headerIconColor]="'#065986'"
                   (click)="overrideGstSettings()"
        ></app-stats>
      }
    </div>
    @if (showInvoiceContent) {
      <div class="full_card">
        @if (invoiceType === InvoiceType.DOCUMENT && accordionTableData.data.length > 0) {
          <div class="table_title">Container Information</div>
          <app-accordion-table
            #accordionTableComponent
            [tableHeaderAndData]="accordionTableData"
            [readOnly]="true"
            (onAccordionOpen)="loadItemAccordionContent($event)"
            (expandedRowIndexChange)="expandedRowIndex = $event"
          ></app-accordion-table>
        }
        @if (invoiceAdHocChargesData.length > 0) {
          <div class="table_title">Ad - hoc Charges</div>
          <app-static-table
            [tableMeta]="chargeTableConfig"
            [data]="invoiceAdHocChargesData"
            [readOnlyMode]="true"
            (rowActionTriggered)="handleInlineActions($event)"
            [deleteAllowed]="false"
            [showCheckBox]="false"
          ></app-static-table>
        }

        <div class="action_btns" *ngIf="!readOnlyMode">
          <button class="button ghost_button" (click)="addDiscounts()">
            @if (discountInvoiceTableData.length === 0 && discountContainerTableData.length === 0) {
              <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
            } @else {
              <app-svg-icon [path]="'assets/icons/pencil_icon.svg'"></app-svg-icon>
            }
            Discounts
          </button>
          <button class="button tertiary_button" (click)="addAdHocCharges()">
            @if (adHocChargesContainerTableData.length === 0 && adHocChargesInvoiceTableData.length === 0) {
              <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
            } @else {
              <app-svg-icon [path]="'assets/icons/pencil_icon.svg'"></app-svg-icon>
            }
            Ad-hoc Charges
          </button>
        </div>
      </div>
      <div class="notes_and_summary">
        <form class="textarea_container" [formGroup]="invoiceFrom">
          <div class="form-group">
            <label for="customerNotes">Customer Notes</label>
            <textarea id="customerNotes" formControlName="customerNotes" class="custom-textarea"
                      placeholder="Enter Customer Notes"></textarea>
          </div>

          <div class="form-group">
            <label for="tallyNotes">Tally Notes</label>
            <textarea id="tallyNotes" formControlName="tallyNotes" class="custom-textarea"
                      placeholder="Enter Tally Notes"></textarea>
          </div>
        </form>
        <div class="summary">
          <div class="summary_content">
            <div class="title">Amount</div>
            <div class="value">{{ documentAmountInfo.amount }}</div>
          </div>
          <div class="summary_content" *ngIf="documentAmountInfo.cgst !== 0">
            <div class="title">CGST</div>
            <div class="value">{{ documentAmountInfo.cgst }}</div>
          </div>
          <div class="summary_content" *ngIf="documentAmountInfo.igst!==0">
            <div class="title">IGST</div>
            <div class="value">{{ documentAmountInfo.igst }}</div>
          </div>
          <div class="summary_content" *ngIf="documentAmountInfo.sgst!==0">
            <div class="title">SGST</div>
            <div class="value">{{ documentAmountInfo.sgst }}</div>
          </div>
          <div class="summary_content" *ngIf="documentAmountInfo.discount!==0">
            <div class="title">Discount</div>
            <div class="value">-{{ documentAmountInfo.discount }}</div>
          </div>
          <div class="summary_content">
            <div class="title">Total Amount</div>
            <div class="value">{{ documentAmountInfo.totalAmount }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

@if (showInvoiceContent) {
  <div class="bottom_bar">
    <div class="content">Total Amount: {{ documentAmountInfo.totalAmount }}</div>
  </div>
}

<!--Charge View Static Table-->
<ng-template #chargesViewTable let-data>
  <app-static-table
    [tableMeta]="chargeTableConfig"
    [data]="data.tableData"
    [readOnlyMode]="true"
    [deleteAllowed]="false"
    [showCheckBox]="false"
    (rowActionTriggered)="handleInlineActions($event)"
    [showBorders]="true"
    [showSerialNumber]="false"
  ></app-static-table>
</ng-template>

<!--Accordion Table-->
<ng-template #addChargesTable>
  <div class="add_charges_table">
    <app-horizontal-tabs
      [tabs]="adHocChargeTabs"
      [selectedTab]="adHocChargeSelectedTab"
      (tabSelected)="handleAdHocChargeTabSelection($event)"
    ></app-horizontal-tabs>
    @switch (adHocChargeSelectedTab) {
      @case ('containerCharge') {
        <form [formGroup]="addAdHocChargesForm" (ngSubmit)="addChargesForContainerFormOnSubmit()">
          <div class="container_charge_selection">
            <div class="form_item">
              <label for="container" class="required_field_label">Container Number</label>
              <app-multi-select id="container"
                                formControlName="container"
                                [options]="containerNumberSelectOptions"
                                [displayKey]="'label'"
                                [valueKey]="'value'"
                                [showChips]="false"
                                [isMultiSelect]="false"
                                [returnRawValue]="true"
              ></app-multi-select>
            </div>
            <div class="link">
              <app-svg-icon class="link-icon" [path]="'assets/icons/link_icon.svg'"></app-svg-icon>
            </div>

            <div class="form_item">
              <label for="charge" class="required_field_label">Charge</label>
              <app-autocomplete-dropdown
                id="charge"
                [formControlName]="'charge'"
                [placeholder]="'Search Charge'"
                [apiUrl]="'v1/charges/list'"
                [selectFields]='["id", "name", "code"]'
                [filterByKeys]='["NAME_CONTAINS", "CODE_CONTAINS"]'
                limit="10"
                [orderBy]='{ "name": "asc" }'
                [filterByKey]="'name'"
                [bindLabel]="'name'"
                [returnRawValue]="true"
                [bindValue]="'id'"
                [displayColumns]='[
            { "key": "name", "header": "Name" },
            { "key": "code", "header": "Code" }
          ]'
              ></app-autocomplete-dropdown>
            </div>
            <div class="add_button">
              <button class="tertiary_button" type="submit" [ngClass]="{
            'disabled': !addAdHocChargesForm.valid
          }">Add Charge
              </button>
            </div>
          </div>
        </form>
        <app-editable-table
          [tableHeaders]="adHocChargesTableConfig"
          [tableData]="adHocChargesContainerTableData"
          [showInputFieldsOnTh]="false"
          [deletionAllowed]="true"
          [uniqueId]="'chargeId'"
          (dataDeleted)="handleAdHocChargeDataDeletion($event)"
        ></app-editable-table>
      }
      @case ('invoiceCharge') {
        <form [formGroup]="addAdHocChargesForm" (ngSubmit)="addAdHocChargesForInvoice()">
          <div class="container_charge_selection">
            <div class="form_item">
              <label for="invoiceCharge" class="required_field_label">Charge</label>
              <app-autocomplete-dropdown
                id="invoiceCharge"
                [formControlName]="'charge'"
                [placeholder]="'Search Charge'"
                [apiUrl]="'v1/charges/list'"
                [filterByKeys]='["NAME_CONTAINS", "CODE_CONTAINS"]'
                limit="10"
                [orderBy]='{ "name": "asc" }'
                [filterByKey]="'NAME_CONTAINS'"
                [bindLabel]="'name'"
                [returnRawValue]="true"
                [bindValue]="'id'"
                [displayColumns]='[
            { "key": "name", "header": "Name" },
            { "key": "code", "header": "Code" }
          ]'
              ></app-autocomplete-dropdown>
            </div>
            <div class="add_button">
              <button class="tertiary_button" type="submit" [ngClass]="{
            'disabled': !addAdHocChargesForm.valid
          }">Add Charge
              </button>
            </div>
          </div>
        </form>
        <app-editable-table
          [tableHeaders]="adHocChargesTableConfig"
          [tableData]="adHocChargesInvoiceTableData"
          [showInputFieldsOnTh]="false"
          [deletionAllowed]="true"
          [uniqueId]="'chargeId'"
          (dataDeleted)="handleAdHocChargeDataDeletion($event)"
        ></app-editable-table>
      }
    }
  </div>
</ng-template>

<!--Discounts Accordion-->
<ng-template #discountsAccordion>
  <div class="discounts_panel">
    <app-horizontal-tabs
      [tabs]="discountTabs"
      [selectedTab]="discountSelectedTab"
      (tabSelected)="handleDiscountsTabSelection($event)"
    ></app-horizontal-tabs>
    @switch (discountSelectedTab) {
      @case ('containerDiscounts') {
        <app-tos-accordion
          [accordionData]="getDiscountTableData()"
          (accordionOpenedEmitter)="handleDiscountAccordionOpened($event)"
          #tosAccordion
        ></app-tos-accordion>
      }
      @case ('invoiceDiscounts') {
        <app-editable-table
          id="invoice_discount_table"
          [tableHeaders]="discountTableConfig"
          [tableData]="this.discountInvoiceTableData"
          [showInputFieldsOnTh]="false"
        ></app-editable-table>
      }
    }
  </div>
</ng-template>

<ng-template #gstSettingsTemplate>
  <form [formGroup]="gstSettingsForm" class="gst_content">
    <div class="gst_applicable_toggle">
      <app-toggle [label]="'GST'" style="width: 288px" [formControlName]="'gstApplicable'" (toggleChange)="onGstToggleChange($event)"></app-toggle>
      <div class="gst_toggle_note">Note: Turning this off will generate the invoice without the GST.</div>
    </div>

    <div class="form_group">
      <label class="required_field_label">GST (%)</label>
      <input type="number" [formControlName]="'gstPercentage'" placeholder="Enter GST (%)" style="width: 288px"
             [ngClass]="{ 'visible': gstSettingsForm.get('gstPercentage')?.invalid && gstSettingsForm.get('gstPercentage')?.touched }" />
      <div
        class="form_validation_error_new"
        [ngClass]="{'visible': gstSettingsForm.get('gstPercentage')?.invalid && gstSettingsForm.get('gstPercentage')?.touched}"
      >
        <small *ngIf="gstSettingsForm.get('gstPercentage')?.errors?.['required']"
        >GST Percentage is required</small
        >
      </div>
    </div>
  </form>

</ng-template>

<ng-template #gstSettingConfirmModal>
  <div class="gst_settings_confirm_modal">
    <img src="assets/icons/error_icon.svg" alt="warning icon" />
    <div class="msg">
      <div class="msg_header">Are you sure you want make this changes?</div>
      <div class="msg_content">Making this changes will affect the GST Creation.</div>
    </div>
  </div>
  <div class="gst_setting_action_btns">
    <button class="secondary_button" (click)="gstChangeConfirmModalComponentRef.destroy()">Cancel</button>
    <button class="primary_button" (click)="setGstSettingsState()">Yes</button>
  </div>
</ng-template>
